import { WizardStep } from "@mittwald/flow-components/dist/components/Wizard/components/WizardStep";
import React from "react";
import { LoadingView } from "@mittwald/flow-components/dist/components/Box";
import { UniversalBoundary } from "@mittwald/flow-components/dist/components/UniversalBoundary";
import type { RelocationReferrer } from "../../../RelocationRequestWidget";
import { TargetStepContent } from "./TargetStepContent";

interface TargetStepProps {
  noReturn?: boolean;
  referrer: RelocationReferrer;
}

export const TargetStep: React.FC<TargetStepProps> = ({
  noReturn,
  referrer,
}) => {
  return (
    <WizardStep id="target" indicatorText="target" noReturn={noReturn}>
      <UniversalBoundary loadingView={<LoadingView _height={200} />}>
        <TargetStepContent referrer={referrer} />
      </UniversalBoundary>
    </WizardStep>
  );
};
